export default __webpack_public_path__ + "app/styles/fonts/Inter/Inter-LightItalic.woff";